// src/utils/formatters.js

/**
 * 시간 문자열 포맷팅 (예: "1500" or "15:00" -> "오후 3:00")
 * @param {string|number} timeInput - HHMM 또는 HH:MM 형식의 값
 * @returns {string} 오전/오후 h:mm 형식의 문자열
 */
export const formatTimeStr = (timeInput) => {
    if (timeInput === null || timeInput === undefined) return "";

    // 숫자면 문자열로 변환
    let timeStr = String(timeInput).trim();

    // 이미 "오전", "오후"가 포함되어 있다면 변환 불필요
    if (timeStr.includes('오전') || timeStr.includes('오후')) {
        return timeStr;
    }

    let hour = 0;
    let minute = "";

    // Case 1: "HH:MM" 형식 (예: "15:00", "07:00")
    if (timeStr.includes(':')) {
        const parts = timeStr.split(':');
        if (parts.length >= 2) {
            hour = parseInt(parts[0], 10);
            minute = parts[1];
        } else {
            return timeStr; // 형식이 이상하면 원본 반환
        }
    }
    // Case 2: "HHMM" 4자리 숫자 형식 (예: "1500")
    else if (timeStr.length === 4 && !isNaN(timeStr)) {
        hour = parseInt(timeStr.substring(0, 2), 10);
        minute = timeStr.substring(2);
    } else {
        return timeStr; // 변환할 수 없는 형식이면 원본 반환
    }

    // --- 12시간제 변환 로직 ---
    let period = '오전';
    let displayHour = hour;

    if (hour >= 12) {
        period = '오후';
        if (hour > 12) {
            displayHour = hour - 12;
        }
    }

    // 0시는 오전 12시로 표기
    if (displayHour === 0) {
        displayHour = 12;
    }

    return `${period} ${displayHour}:${minute}`;
};

/**
 * 시간 문자열 포맷팅 (24시간제) (예: "1500" or "15:00" -> "15:00")
 * @param {string|number} timeInput - HHMM 또는 HH:MM 형식의 값
 * @returns {string} HH:mm 형식의 문자열
 */
export const formatTimeStr24 = (timeInput) => {
    if (timeInput === null || timeInput === undefined) return "";

    let timeStr = String(timeInput).trim();

    if (timeStr.includes(':')) {
        const parts = timeStr.split(':');
        if (parts.length >= 2) {
            return `${parts[0].padStart(2, '0')}:${parts[1]}`;
        }
    } else if (timeStr.length === 4 && !isNaN(timeStr)) {
        return `${timeStr.substring(0, 2)}:${timeStr.substring(2)}`;
    }

    return timeStr;
};